export const textTranslations = (section, language, props) => {
    if(language === "english") {
        if(section === "main") {
            return <span onClick={() => window.location.href = "https://theboggler.com"}>&copy; 2026 The Boggler Inc. <br className="break-on-mobile" /> | 🪷 crafted with wisdom and care 🪷 | </span>
        }
        if(section === "privacy-policy") {
            return "Privacy Policy"
        }
        if(section === "terms-of-use") {
            return "Terms of Service"
        }
    } else if(language === "sinhala") {
        if(section === "main") {
            return <span onClick={() => window.location.href = "https://theboggler.com"}>&copy; 2026 The Boggler Inc. <br className="break-on-mobile" /> | 🪷 pragnāva saha sælakillen nirmāṇaya karana ladī 🪷 | </span>
        }
        if(section === "privacy-policy") {
            return <span>rahasyatā prathipattiya</span>
        }
        if(section === "terms-of-use") {
            return <span>bhāvithā kondēsi</span>
        }
    }
}